import { useT } from '../../lib/i18n'
import { EyeOff } from './Icons'

export default function Privacy () {
  const p = useT().privacy
  return (
    <section className="lp-sec" id="privacy">
      <div className="lp-wrap lp-priv">
        <div className="lp-priv__head lp-rv">
          <span className="lp-priv__badge" aria-hidden="true"><EyeOff /></span>
          <span className="lp-kicker">{p.kicker}</span>
          <h2 className="lp-h2">{p.title}</h2>
          <p className="lp-lead">{p.lead}</p>
          <p className="lp-priv__note">{p.note}</p>
        </div>
        <ol className="lp-priv__l">
          {p.items.map((i, n) => (
            <li key={i.t} className="lp-rv">
              <span className="lp-priv__n">{String(n + 1).padStart(2, '0')}</span>
              <b>{i.t}</b>
              <span>{i.p}</span>
            </li>
          ))}
        </ol>
      </div>
    </section>
  )
}
